import { Component, OnInit, ElementRef } from "@angular/core";
import { Injectable, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
} from "@angular/forms";
import { Router } from "@angular/router";
import { DaoService } from "./../../services/dao.service";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
//import { Country } from 'src/app/auth/login/login.component';
import { UserformComponent } from "../userform/userform.component";
import { UserconfigComponent } from "../userconfig/userconfig.component";
import { UseractivityComponent } from "../useractivity/useractivity.component";
import { UseraccountlockformComponent } from "../useraccountlockform/useraccountlockform.component";
import { UserdeleteComponent } from "../userdelete/userdelete.component";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";

export interface Country {
  name: string;
  code: string;
  img: string;
}

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.scss"],
})
export class UserComponent implements OnInit {
  [x: string]: any;

  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    // this.setDataSourceUser();
  }

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  countryCodes: Country[] = [
    { name: "India", code: "+91", img: "assets/img/Flag-India.jpg" },
    { name: "USA", code: "+1", img: "assets/img/flag-usa.png" },
    { name: "UK", code: "+44", img: "assets/img/flag-aus.jpg" },
  ];

  dataSource: any;
  user: any;
  userList: any;
  userActivityId: any;
  private paginator: MatPaginator;
  // tslint:disable-next-line: variable-name
  public created_By: any;
  public modified_By: any;
  displayedColumns: string[] = [
    "Sno",
    "mobile",
    "configure",
    "activity",
    "isLock",
    "edit",
    "delete",
  ];
  public validator = {
    errorMessage: "",
    UniqueUser: false,
  };
  public shown = {
    grid: true,
    Form: false,
  };
  public userEdit = {
    edit: false,
  };

  User = new FormGroup({
    userId: new FormControl(),
    userName: new FormControl(),
    firstName: new FormControl(),
    lastName: new FormControl(),
    gender: new FormControl(),
    email: new FormControl(),
    countryCode: new FormControl(),
    mobile: new FormControl(),
    isSuperAdmin: new FormControl(),
    role: new FormControl(),
    token: new FormControl(),
    isActive: new FormControl(),
    isLock: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  pageIndex: number;
  pageSize: number;
  length: number;
  @ViewChild("searchMobileNumber", { static: false }) el: ElementRef;
  constructor(
    private router: Router,
    private daoService: DaoService,
    private fb: FormBuilder,
    private token: LstorageService,
    public dialog: MatDialog,
    private spinner: SpinnerService
  ) {}
  ngOnInit() {
    this.spinner.show();
    this.daoService.getUserList().subscribe((data: any) => {
      this.daoService.defaultUserList(data);
      this.daoService.finalUserList.subscribe((userList) => {
        this.userList = userList;
        this.el.nativeElement.value = "";
      });
      this.dataSource = new MatTableDataSource(this.userList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //For filter specific column
      this.dataSource.filterPredicate = function (
        data,
        filter: string
      ): boolean {
        return data.mobile.toLowerCase().includes(filter);
      };
      console.log("Datasort");
      console.log(this.dataSource.sort);
      this.spinner.hide();
    });

    this.created_By = jwtDecode(this.token.getToken());
    this.User = this.fb.group({
      userId: [""],
      userName: ["", [Validators.required]],
      firstName: [""],
      lastName: [""],
      gender: [""],
      email: [""],
      countryCode: ["", [Validators.required]],
      mobile: [],
      isSuperAdmin: [""],
      role: ["", [Validators.required]],
      token: [""],
      isActive: ["", [Validators.required]],
      isLock: ["", [Validators.required]],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-10-05T03:47:43.629Z"],
      modifiedBy: [""],
      modifiedOn: ["2019-11-04T18:38:21.751Z"],
    });
  }

  // getSelectedType(event) {
  //     if (event.value == "General") {
  //         this.isGeneralType = true;
  //     } else {
  //         this.isGeneralType = false;
  //     }
  // }

  // accountlock(event) {
  //     if (event.value == "General") {
  //         this.isGeneralType = true;
  //     } else {
  //         this.isGeneralType = false;
  //     }
  // }

  public userFilter = (value: string) => {
    value = value.trim(); // Remove whitespace
    value = value.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = value;
  };

  setDataSourceUser() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.setDataSourceUser();
  }

  UserForm() {
    this.userEdit.edit = false;
    this.shown.grid = false;
    this.shown.Form = true;
    this.User = this.fb.group({
      userId: [""],
      userName: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern("[0-9]+$"),
        ],
      ],
      firstName: ["string"],
      lastName: ["string"],
      gender: ["string"],
      email: ["string"],
      countryCode: [""],
      mobile: [],
      isSuperAdmin: ["false"],
      role: [""],
      token: ["string"],
      isActive: ["true"],
      isLock: [""],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-10-05T03:47:43.629Z"],
      modifiedBy: [""],
      modifiedOn: ["2019-11-04T18:38:21.751Z"],
    });
  }

  // createUser() {
  //     this.validator.UniqueUser = false;
  //     this.User.value.mobile = this.User.value.userName;
  //     this.daoService.AddUser(this.User.value).subscribe(data => {
  //         this.backuserList();
  //     });
  //     // tslint:disable-next-line: no-unused-expression
  //     (error) => {
  //         this.validator.UniqueUser = true;
  //         this.validator.errorMessage = error.error.userMessage;
  //     };
  // }

  editUser(id) {
    this.daoService.changeUserId(id);
    const dialogRef = this.dialog.open(UserformComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "442px",
      height: "285px",
      autoFocus: false,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.finalUserList.subscribe((userList) => {
        this.userList = userList;
        this.el.nativeElement.value = "";
      });
      this.dataSource = new MatTableDataSource(this.userList);
      this.daoService.changeUserId(null);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  deleteUser(id, index) {
    this.daoService.changeUserId(id);
    this.daoService.userDelete(true);
    const dialogRef = this.dialog.open(UserdeleteComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "145px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.userDelete(false);
      this.daoService.finalUserList.subscribe(
        (userList) => (this.userList = userList)
      );
      console.log("before close");
      console.log(this.userList);
      this.dataSource = new MatTableDataSource(this.userList);
      this.daoService.changeUserId(null);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  unlock(id) {
    this.User.value.userId = id;
    this.User.value.isLock = false;
    this.User.value.modifiedBy = this.created_By.unique_name;
    this.User.value.isActive = true;
    this.User.value.isSuperAdmin = true;
    this.daoService.lockUser(this.User.value).subscribe((data: any) => {
      if (data.isSuccess) {
        this.daoService.dynamiclockUserList(data.data);
        this.dataSource = new MatTableDataSource(this.userList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter(
      (l_cur_row) => l_cur_row[p_key] != p_value_to_remove
    );
  }
  backuserList() {
    this.shown.grid = true;
    this.shown.Form = false;
    this.daoService.getUserList().subscribe((data: any) => {
      this.userList = data;
      this.dataSource = new MatTableDataSource(this.userList);
      this.dataSource.paginator = this.paginator;
    });
  }
  allowOnlyNumbers(event) {
    if (
      !(
        (event.keyCode > 95 && event.keyCode < 106) ||
        (event.keyCode > 47 && event.keyCode < 58) ||
        event.keyCode === 8
      )
    ) {
      return false;
    }
  }
  openDialog(): void {
    this.dataSource.filter = "";
    const dialogRef = this.dialog.open(UserformComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "442px",
      height: "285px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.finalUserList.subscribe((userList) => {
        this.userList = userList;
        this.el.nativeElement.value = "";
      });
      this.dataSource = new MatTableDataSource(this.userList);
      this.daoService.changeUserId(null);
      this.dataSource.paginator = this.paginator;
    });
  }
  openuserconfigdialog(id): void {
    this.daoService.changeUserId(id);
    const dialogRef = this.dialog.open(UserconfigComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "786px",
      height: "600px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.changeUserId(null);
    });
  }
  openactivitydialog(id): void {
    this.daoService.changeUseractivityId(id);
    const dialogRef = this.dialog.open(UseractivityComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "746px",
      height: "494px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.changeUserId(null);
    });
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  openlockDialog(id) {
    this.daoService.changeUserId(id);
    const dialogRef = this.dialog.open(UseraccountlockformComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "145px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.dataSource = new MatTableDataSource(this.userList);
      this.daoService.changeUserId(null);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }
  //
  openunlockDialog(id) {
    this.daoService.changeUserId(id);
    this.daoService.unlockUser(true);
    const dialogRef = this.dialog.open(UseraccountlockformComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "145px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.unlockUser(false);
      this.dataSource = new MatTableDataSource(this.userList);
      this.daoService.changeUserId(null);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (this.dataSource.filter.length > 9) {
      return false;
    }
    return true;
  }

  //For store pagination details
  public handlePage(e: any) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.length = e.length;
  }
}
